var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("form", { staticClass: "header__search-form" }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.query,
          expression: "query",
        },
      ],
      staticClass: "form-control header__search-input",
      attrs: {
        type: "search",
        placeholder: "Поиск продукта",
        "aria-label": "Search",
      },
      domProps: { value: _vm.query },
      on: {
        input: [
          function ($event) {
            if ($event.target.composing) return
            _vm.query = $event.target.value
          },
          function ($event) {
            return _vm.searchAutocomplete()
          },
        ],
      },
    }),
    _vm._v(" "),
    _c(
      "button",
      { staticClass: "btn header__search--btn", attrs: { type: "submit" } },
      [
        _c(
          "svg",
          {
            attrs: {
              width: "16",
              height: "16",
              viewBox: "0 0 16 16",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
            },
          },
          [
            _c("circle", {
              attrs: { cx: "6.5", cy: "6.5", r: "6", stroke: "#2F324E" },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M11 11L15 15",
                stroke: "#2F324E",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
              },
            }),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _vm.search_results && _vm.search_results.length > 0
      ? _c(
          "ul",
          { staticClass: "dropdown-autocomplete" },
          _vm._l(_vm.search_results, function (item, index) {
            return _c(
              "li",
              { key: item.id, staticClass: "dropdown-autocomplete__item" },
              [
                _c("a", { attrs: { href: item.get_absolute_url } }, [
                  _vm._v(_vm._s(item.title)),
                ]),
              ]
            )
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }